/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

/**
 * Internal dependencies
 */
import { requestInvoices } from 'state/invoices/actions';
import { getAllInvoices, requestingInvoices, errorRequestingInvoices } from 'state/invoices/selectors';
import Loader from './loader';
import Money from 'components/money';
import DateTime from 'components/date-time';
import InvoiceStatus from 'components/invoice-status';
import Icon from 'components/icon';
import ErrorContent from 'modules/me/error-content';
import cscom from 'lib/customer-site-api';
import { Box, Text } from '@towersystems/towersystems-design-system';
import Card from 'components/card';

/**
 * Style dependencies
 */
import './styles.scss';

const Invoices = (props) => {
    const [invoices, setInvoices] = useState(props.invoices);

    const downloadInvoice = (id) => {
        cscom
            .invoice()
            .downloadInvoice(id)
            .then(({ download }) => {
                window.location = download;
            });
    };

    useEffect(() => {
        props.requestInvoices().then((invoices) => setInvoices(invoices));
    }, []);

    if (isEmpty(invoices) && true == props.requesting) {
        return <Loader />;
    }

    if (isEmpty(invoices)) {
        return (<Box></Box>);
    } else {
        return (
            <Box style={{ overflowX: 'auto' }}>
                <table className='invoices-list__table'>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Invoice</th>
                            <th>Status</th>
                            <th className='text-right'>Amount</th>
                            <th className='text-right'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.map((invoice) => {
                            if(isEmpty(invoice.issued_credit_notes)) {
                                if(!isEmpty(invoice.adjustment_credit_notes)) {
                                    return (invoice.adjustment_credit_notes.map((credit_note) => (
                                        [(<tr key={credit_note.id}>
                                            <td>
                                                <Text fontSize='large' weight='strong'>
                                                    <DateTime date={credit_note.cn_date} format='Do MMM, YYYY' />
                                                </Text>
                                            </td>
                                            <td>
                                                #{credit_note.cn_id}
                                            </td>
                                            <td>
                                                <InvoiceStatus status={credit_note.cn_status} />
                                            </td>
                                            <td className='text-right font-weight-bold'>
                                                <Money value={credit_note.cn_total / 100} />
                                            </td>
                                            <td className='text-right'>
                                                {credit_note.cn_create_reason_code}
                                            </td>
                                        </tr>),(<tr key={invoice.id}>
                                        <td>
                                            <Text fontSize='large' weight='strong'>
                                                <DateTime date={invoice.date} format='Do MMM, YYYY' />
                                            </Text>
                                        </td>
                                        <td>
                                            #{invoice.id}
                                        </td>
                                        <td>
                                            <InvoiceStatus status={invoice.status} />
                                        </td>
                                        <td className='text-right font-weight-bold'>
                                            <Money value={invoice.total / 100} />
                                        </td>
                                        <td className='text-right'>
                                            <a href='#!' onClick={() => downloadInvoice(invoice.id)}>
                                                <Icon name='FiDownload' />
                                            </a>
                                        </td>
                                    </tr>)]
                                    )));
                                }
                                return (
                                    <tr key={invoice.id}>
                                        <td>
                                            <Text fontSize='large' weight='strong'>
                                                <DateTime date={invoice.date} format='Do MMM, YYYY' />
                                            </Text>
                                        </td>
                                        <td>
                                            #{invoice.id}
                                        </td>
                                        <td>
                                            <InvoiceStatus status={invoice.status} />
                                        </td>
                                        <td className='text-right font-weight-bold'>
                                            <Money value={invoice.total / 100} />
                                        </td>
                                        <td className='text-right'>
                                            <a href='#!' onClick={() => downloadInvoice(invoice.id)}>
                                                <Icon name='FiDownload' />
                                            </a>
                                        </td>
                                    </tr>
                                );
                            }
                        })}
                    </tbody>
                </table>
            </Box>
        );
    }
};

export default connect(
    (state) => ({
        invoices: getAllInvoices(state),
        requesting: requestingInvoices(state),
        error: errorRequestingInvoices(state),
    }),
    {
        requestInvoices,
    },
)(Invoices);
